<template>
 <ul class="px-[10px]">
    <AccountCard
      v-for="value in accounts.items"
      :key="value.id"
      :account="value" />
  </ul>
</template>

<script>
import AccountCard from '@/components/common/AccountCard.vue';

export default {
  name: 'AllAccountsList',
  components: {
    AccountCard,
  },
  props: {
    accounts: {
      type: Object,
      default: () => ({ items: [] })
    }
  }
}
</script>

<style scoped>
/* Component styles are handled by Tailwind classes */
</style>
